/** Russian strings (default language). Keys are shared by uz.ts and en.ts. See docs/I18N.md. */

export const ru = {
  'app.title': 'Симулятор зрения и линз',
  'lang.ru': 'Русский',
  'lang.uz': 'Oʻzbekcha',
  'lang.en': 'English',

  'app.subtitle': 'Слева — как вы видите сейчас, справа — как будете видеть после выбранного лечения.',
  'step.now': '1. Как вы видите сейчас',
  'step.after': '2. Лечение',
  'step.scene': 'Где смотрим',
  'badge.now': 'Сейчас, без лечения',
  'badge.after': 'После лечения',
  'age': 'Возраст',
  'target': 'Линза настроена',
  'target.far': 'вдаль',
  'target.near': 'вблизи',
  'gaze': 'Взгляд следует за курсором',
  'zoom': 'Увеличить картинку',
  'tags': 'Подписи расстояний',
  'how': 'Как это работает',
  'webgl.error': 'Для симуляции нужен браузер с WebGL2: Chrome, Edge, Firefox или Safari 16+.',
  'rendering': 'Рендеринг…',
  'stage': 'Стадия',
  'tag.far': '5 м',
  'tag.mid': '66 см',
  'tag.near': '40 см',
  'tag.m4': '4 м',
  'tag.m30': '30 м',
  'tag.m60': '60 м',
  'tag.cm75': '75 см',
  'tag.cm45': '45 см',
  'zoom.hint': 'Прокручивайте картинку',

  'treat.title': 'Способ лечения',
  'treat.none': 'Без лечения',
  'treat.glasses': 'Очки или мягкие линзы',
  'treat.glasses_aphakic': 'Очки для афакии',
  'treat.progressive': 'Прогрессивные очки',
  'treat.progressive_aphakic': 'Бифокальные очки для афакии',
  'treat.rgp': 'Жёсткие контактные линзы',
  'treat.rgp_aphakic': 'Контактные линзы для афакии',
  'treat.lasik': 'Лазерная коррекция',
  'treat.icl': 'Факичная линза (ICL)',
  'treat.iol': 'Замена хрусталика',
  'lens.title': 'Искусственный хрусталик (ИОЛ)',
  'lens.iol_mono': 'Монофокальный',
  'lens.iol_monoplus': 'Монофокальный+',
  'lens.iol_edof': 'EDOF',
  'lens.iol_tri': 'Трифокальный',
  'version.title': 'Версия линзы',
  'version.plain': 'Обычная',
  'version.toric': 'Торическая — исправляет астигматизм',

  'refr.title': 'Рефракция',
  'refr.hint': 'Из рецепта на очки или распечатки авторефрактометра. Цилиндр можно ввести и с плюсом.',
  'refr.se': 'Сфероэквивалент {x}',
  'refr.meridians': 'меридианы {m1} и {m2}',
  'refr.kind.emmetropia': 'эмметропия',
  'refr.kind.myopia': 'миопия',
  'refr.kind.hyperopia': 'гиперметропия',
  'astig.simple_myopic': 'простой миопический астигматизм',
  'astig.compound_myopic': 'сложный миопический астигматизм',
  'astig.simple_hyperopic': 'простой гиперметропический астигматизм',
  'astig.compound_hyperopic': 'сложный гиперметропический астигматизм',
  'astig.mixed': 'смешанный астигматизм',

  'cond.title': 'Заболевания глаз',
  'cond.aphakia': 'Афакия (нет хрусталика)',
  'cond.aphakia.info': 'Глаз без хрусталика: нет собственной фокусировки, SPH обычно около +10…+12 D.',
  'cond.cataract': 'Катаракта',
  'cond.cataract.stages': ['начальная', 'незрелая', 'зрелая', 'перезрелая'],
  'cond.kc': 'Кератоконус',
  'cond.kc.stages': ['стадия I', 'стадия II', 'стадия III', 'стадия IV'],
  'cond.glaucoma': 'Глаукома',
  'cond.glaucoma.stages': ['начальная', 'развитая', 'далеко зашедшая', 'терминальная'],
  'cond.amd': 'ВМД (возрастная макулярная дегенерация)',
  'cond.amd.stages': ['ранняя', 'промежуточная', 'поздняя'],
  'cond.dr': 'Диабетическая ретинопатия',
  'cond.dr.stages': ['непролиферативная', 'препролиферативная', 'пролиферативная'],
  'cond.hr': 'Гипертоническая ретинопатия',
  'cond.hr.stages': ['ангиопатия', 'ангиосклероз', 'ретинопатия', 'нейроретинопатия'],
  'cond.rp': 'Пигментный ретинит',
  'cond.rp.stages': ['начальная', 'умеренная', 'выраженная', 'терминальная'],
  'cond.amblyopia': 'Амблиопия («ленивый глаз»)',
  'cond.amblyopia.stages': ['очень слабая', 'слабая', 'средняя', 'высокая', 'очень высокая'],
  'cond.amblyopia.visus': ['Visus 0.8–0.9', 'Visus 0.4–0.7', 'Visus 0.2–0.3', 'Visus 0.05–0.1', 'Visus ≤ 0.04'],
  'cond.amblyopia.hint': 'Visus — лучшая острота с коррекцией при этой степени; без коррекции ниже.',

  'corr.none.label': 'Без коррекции',
  'corr.none.desc': 'Как глаз видит сейчас.',
  'corr.glasses.label': 'Очки / мягкие линзы (для дали)',
  'corr.glasses.desc': 'Исправляют миопию, дальнозоркость и астигматизм. После ~45 лет вблизи без очков для чтения будет размыто.',
  'corr.glasses_aphakic.label': 'Очки для афакии',
  'corr.glasses_aphakic.desc': 'Толстые плюсовые линзы (около +10…+12 D): даль видна чётко, для чтения нужна дополнительная сила. Предметы кажутся примерно на четверть крупнее, поле зрения сужается, по краям искажения.',
  'corr.progressive.label': 'Прогрессивные очки',
  'corr.progressive.desc': 'Верх линзы для дали, середина для экрана, низ для чтения.',
  'corr.progressive_aphakic.label': 'Бифокальные / прогрессивные очки для афакии',
  'corr.progressive_aphakic.desc': 'Верх для дали, низ для чтения с полной добавкой (около +3 D): без хрусталика собственной фокусировки нет. Увеличение как у очков для афакии.',
  'corr.rgp.label': 'Жёсткие / склеральные линзы',
  'corr.rgp.desc': 'При кератоконусе выравнивают неровную роговицу; обычно дают лучшую чёткость.',
  'corr.rgp_aphakic.label': 'Контактные линзы для афакии',
  'corr.rgp_aphakic.desc': 'Линза лежит на роговице: изображение увеличено меньше (около 8 %), поле зрения шире, чем в очках для афакии.',
  'corr.lasik.label': 'Лазерная коррекция (LASIK / SMILE)',
  'corr.lasik.desc': 'Меняет форму роговицы. Ночью возможны ореолы. Возрастную дальнозоркость не устраняет.',
  'corr.icl.label': 'Факичная линза (ICL)',
  'corr.icl.desc': 'Имплантируется перед собственным хрусталиком; способность фокусироваться сохраняется. Часто при высокой миопии.',
  'corr.iol_mono.label': 'ИОЛ монофокальная',
  'corr.iol_mono.desc': 'Чёткость на одной дистанции (обычно вдаль). Для чтения понадобятся очки. Минимум ореолов.',
  'corr.iol_monoplus.label': 'ИОЛ монофокальная+ (улучшенная)',
  'corr.iol_monoplus.desc': 'Немного расширяет чёткость на средней дистанции; ореолы как у монофокальной.',
  'corr.iol_edof.label': 'ИОЛ EDOF (расширенная глубина фокуса)',
  'corr.iol_edof.desc': 'Даль и средняя дистанция без очков; для мелкого текста иногда нужны очки. Ореолы небольшие.',
  'corr.iol_tri.label': 'ИОЛ трифокальная (мультифокальная)',
  'corr.iol_tri.desc': 'Даль, средняя дистанция и чтение без очков. Свет делится между фокусами: ниже контраст, ночью ореолы вокруг фар.',
  'corr.icl_toric.label': 'Факичная линза (ICL) торическая',
  'corr.iol_mono_toric.label': 'ИОЛ монофокальная торическая',
  'corr.iol_monoplus_toric.label': 'ИОЛ монофокальная+ торическая',
  'corr.iol_edof_toric.label': 'ИОЛ EDOF торическая',
  'corr.iol_tri_toric.label': 'ИОЛ трифокальная торическая',
  'corr.toric.desc': 'Торическая версия дополнительно исправляет астигматизм.',

  'w.kc_lasik': 'При кератоконусе лазерная коррекция обычно противопоказана.',
  'w.high_lasik': 'При миопии сильнее −8…−10 D лазер обычно не применяют; чаще рассматривают ICL.',
  'w.lasik_near': 'После лазерной коррекции миопии зрение вблизи без очков с возрастом ухудшается: собственная близорукость больше не помогает читать, а пресбиопия остаётся.',
  'w.aphakia_lasik': 'При афакии лазерную коррекцию обычно не применяют: дальнозоркость слишком высокая. Рассматривают ИОЛ или контактные линзы.',
  'w.cat_icl': 'При катаракте ICL не ставят: обычно меняют хрусталик.',
  'w.cat_glasses': 'Очки и лазер не убирают помутнение хрусталика.',
  'w.retina_multi': 'Мультифокальные и EDOF-линзы снижают контраст; при ВМД, глаукоме, ретинопатии и пигментном ретините их обычно не рекомендуют. Обсудите с врачом.',
  'w.astig_nontoric': 'Астигматизм останется: есть торические версии линз.',
  'w.retina_any': 'Замена хрусталика и очки не восстанавливают сетчатку и зрительный нерв.',
  'w.clear_lens_young': 'Замену прозрачного хрусталика до 40 лет делают редко: теряется собственная фокусировка.',
  'w.amblyopia': 'При амблиопии («ленивый глаз») коррекция поднимает остроту только до предела, который задаёт степень амблиопии: зрительная система не развилась в детстве. Лечение возможно в раннем возрасте. Обсудите с врачом.',

  'n.aphakia': 'Афакия — глаз без хрусталика. Без коррекции — сильная дальнозоркость и нет фокусировки вблизи. Очки для афакии увеличивают предметы примерно на четверть и сужают поле зрения, контактные линзы увеличивают меньше; часто вторично имплантируют ИОЛ.',
  'n.rp_dark': 'При пигментном ретините трудно видеть при переходе из светлого помещения в тёмное: глаза привыкают к темноте намного дольше и хуже, чем здоровые. Кнопка «Из светлого в тёмное» под картинками показывает это рядом со здоровым глазом.',
  'n.hr': 'Гипертоническая ретинопатия — изменения сосудов сетчатки при повышенном давлении. На ранних стадиях зрение обычно не меняется, изменения видит врач на глазном дне; на поздних появляются очаги, отёк и снижение зрения. Важен контроль давления.',
  'n.dysphotopsia': 'Возможны дисфотопсии — световые эффекты: ореолы (светящиеся кольца вокруг огней), блики и засветка, лучи-«звёзды». Сильнее ночью и при широком зрачке, со временем обычно становятся менее заметны. Крупно их показывает сцена «Ночные огни».',

  'demo.dark': '▶ Из светлого в тёмное: привыкание к темноте',
  'demo.stop': '■ Остановить показ',
  'demo.caption': 'Из светлого помещения — в темноту · прошло {x} мин',
  'demo.left': 'Без пигментного ретинита',
  'demo.right': 'С пигментным ретинитом',

  'disclaimer': 'Только для ознакомления. Не является медицинским изделием и не предназначено для диагностики или выбора лечения. Реальное зрение зависит от глаза, мозга, освещения и привыкания. Решение принимайте вместе с врачом.',

  'how.items': [
    'Каждый предмет сцены стоит на своём расстоянии: вдаль, 66 см или 40 см. Для каждого расстояния модель прослеживает лучи через зрачок с учётом аберраций глаза и выбранной линзы и размывает изображение отдельно для красного, зелёного и синего света.',
    'Возраст задаёт запас фокусировки (пресбиопию) и размер зрачка; освещённость сцены тоже меняет зрачок.',
    'Мультифокальные и EDOF-линзы делят свет между фокусами: несфокусированная часть света даёт ореолы вокруг ярких огней. Рассеяние в глазу даёт засветку, неровности хрусталика и роговицы — лучи-«звёзды». Экран не бывает таким ярким, как фары, поэтому ночные сцены показаны со сжатием яркости: так ореолы и блики остаются видны. Крупно их показывает сцена «Ночные огни».',
    'Катаракта: рассеяние света (дымка, засветка), пожелтение и неровные аберрации. Глаукома, ВМД, диабетическая и гипертоническая ретинопатия, пигментный ретинит поражают сетчатку и нерв; они показаны размытием и «затиранием», а не чёрными пятнами, потому что так их описывают сами пациенты. Амблиопия — «ленивый глаз»: оптика в порядке, но мозг не научился видеть резко; показана как размытие, которое коррекция не убирает. Афакия — глаз без хрусталика: сильная дальнозоркость и нет фокусировки вблизи.',
    'Это упрощение. Вы смотрите на экран своими глазами, мозг неделями привыкает к новым линзам, а линзы показаны как общие типы, а не конкретные модели. Острота зрения — приблизительная оценка модели.',
  ],

  'scene.chart': 'Таблица Сивцева',
  'scene.home': 'Дом (чтение)',
  'scene.city_day': 'Город — день',
  'scene.city_night': 'Город — ночь',
  'scene.night_lights': 'Ночные огни (крупно)',

  'home.tv.title': 'ПОГОДА',
  'home.tv.cities': ['Ташкент +31°', 'Самарканд +29°', 'Бухара +33°', 'Нукус +27°'],
  'home.tv.ticker': 'Завтра солнечно, ветер слабый',
  'home.laptop.title': 'Как сохранить зрение после 40',
  'home.laptop.body': [
    'Проверяйте зрение раз в год, даже если видите хорошо.',
    'Катаракта развивается медленно и часто незаметно.',
    'Глаукома на ранних стадиях не болит и не мешает.',
    'Делайте перерывы при работе за экраном.',
    'Носите солнцезащитные очки с UV-фильтром.',
    'При внезапном ухудшении зрения сразу обращайтесь к врачу.',
  ],
  'home.phone.msgs': [
    'Здравствуйте! Напоминаем о приёме у офтальмолога',
    'Завтра, 10:00, кабинет 204',
    'Спасибо, буду!',
    'Возьмите, пожалуйста, ваши очки',
  ],
  'home.calendar': 'Сентябрь 2026',
  'city.phone.turn': 'поверните направо',
  'city.phone.eta': 'Прибытие 18:56 · 4 км',
  'chart.near': [
    'Хорошее зрение',
    'помогает читать',
    'книги и сообщения',
    'без лишнего напряжения.',
    'Мелкий шрифт на упаковке лекарств',
    'и в договорах требует чёткого зрения вблизи.',
    'После 45 лет многим нужны очки для чтения',
    'или линзы с фокусом на разных расстояниях.',
  ],
} as const;

export type StringTable = { [K in keyof typeof ru]: (typeof ru)[K] extends readonly string[] ? readonly string[] : string };
